import { Injectable } from '@angular/core';
import { FlamingoHttpService } from '@flamingo/service/flamingo-http.service';
import { Observable } from 'rxjs';
import {
  CompanyImportRequest,
  CompanyImportResponse,
  CompanyImportUpdateDto,
  CompanyValidateDto,
} from '../../../../../../../core/model/company-import-text.model';

@Injectable({
  providedIn: 'root',
})
export class MassiveCompanyImportDialogService {

  constructor(private _httpService: FlamingoHttpService) {
  }

  importText(body: CompanyImportRequest): Observable<CompanyImportResponse> {
    return this._httpService.post('/partner/import/text', body);
  }

  importXls(attachment: FormData): Observable<CompanyImportResponse> {
    return this._httpService.postFormData('/partner/import/xls', attachment);
  }

  getJobStatus(jobId: number): Observable<CompanyImportResponse> {
    return this._httpService.get(`/partner/jobs/${jobId}`);
  }

  importUpdate(body: CompanyImportUpdateDto): Observable<CompanyImportResponse> {
    return this._httpService.post('/partner/import/update', body);
  }

  importConfirm(jobId: number): Observable<CompanyImportResponse> {
    return this._httpService.post('/partner/import/confirm', { jobId });
  }

  updateContact(body: CompanyValidateDto): Observable<CompanyImportResponse> {
    return this._httpService.post('/partner/import/update-contact', body);
  }

}
